export const TiloLanguagesAll: string[] = [
  'Bulgarian',
  'Chinese (Simplified)',
  'Chinese (Traditional)',
  'Czech',
  'Dutch',
  'English',
  'Estonian',
  'Finnish',
  'French',
  'German',
  'Greek',
  'Hebrew',
  'Indonesian',
  'Italian',
  'Japanese',
  'Latvian',
  'Lithuanian',
  'Polish',
  'Portuguese',
  'Romanian',
  'Russian',
  'Slovak',
  'Slovenian',
  'Spanish',
  'Traditional Chinese',
  'Turkish',
  'Vietnamese'
];

export const TiloLanguagesByDoors: Record<8 | 12, string[]> = {
  8: [
    'Bulgarian',
    'Chinese (Simplified)',
    'Chinese (Traditional)',
    'Dutch',
    'English',
    'Estonian',
    'Finnish',
    'French',
    'German',
    'Greek',
    'Indonesian',
    'Italian',
    'Japanese',
    'Latvian',
    'Lithuanian',
    'Polish',
    'Portuguese',
    'Romanian',
    'Russian',
    'Slovak',
    'Slovenian',
    'Spanish',
    'Traditional Chinese',
    'Vietnamese'
  ],
  12: [
    'Chinese (Simplified)',
    'Chinese (Traditional)',
    'Czech',
    'Dutch',
    'English',
    'Estonian',
    'Finnish',
    'French',
    'German',
    'Greek',
    'Hebrew',
    'Indonesian',
    'Italian',
    'Latvian',
    'Lithuanian',
    'Polish',
    'Portuguese',
    'Romanian',
    'Russian',
    'Slovenian',
    'Spanish',
    'Traditional Chinese',
    'Turkish',
    'Vietnamese'
  ]
};
